module.exports = __webpack_public_path__ + "static/media/yourlogo.446aeaa3.png";